import React, { Component } from "react";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import BreadcrumbsSection from "../../breadcrumbs/BreadcrumbsSection";
import DataTableWithOutSearch from "../../datatables/DataTableWithOutSearch";
import StudentModal from "./StudentModal";
import StudentModalEdit from "./StudentModalEdit";
import { Data, Columns, defaultSorted } from "./StudentTableData";
import { components } from 'react-select'
import "./_students.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import StudentPasswordModal from "./StudentPasswordModal";
import { Link } from "react-router-dom";
import CardLessDataTableWithSearch from '../../datatables/CardLessDataTableWithSearch'
import UpdateStudentsModal from "./UpdateStudentsModal";
import MultiSelect from "react-multi-select-component";
import MultiSelectDropdown from "../../reusableDropDownComponents/MultiSelectDropdown";
import { canView } from "../../../../utils/modulePermissions";
import {
  attachModuleGuard,
  AccessDeniedModal,
  AccessDeniedCard,
} from "../../../../utils/moduleGuard";
import { scopeBranches, onBranchScopeChange } from "../../../../utils/branchScope";

// /settings/students → "academic_students" (see MODULE_ROUTES in moduleAccessGuard).
// module_key ONLY, never module_name: the sidebar group name is shared by sibling
// modules, and can() grants an action when ANY matched row allows it — matching the
// group would let another module's grant leak in.
const ACADEMIC_STUDENTS_MODULE = ["academic_students"];


const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
      </components.DropdownIndicator>
    )
  );
};


const FETCH_STUDENTS = gql`
  query($institution_id: Int!) {
    getStudents(institution_id: $institution_id) {
      id
      student_name
      contact_no
      branch_id
      class_id
      section_id
      exam_id
      is_non_academic_exist
      is_academic_exist
      district_id
      state_id
      city_id
    }
  }
`;

const EDIT_STUDENT = gql`
  mutation($params: EditStudentInput) {
    editStudent(params: $params)
  }
`;
const UPDATE_PASSWORD = gql`
  mutation($params: UpdatePassword) {
    updatePassword(params: $params)
  }
`;
const DELETE_STUDENT = gql`
  mutation($studentId: ID,$mobile:String) {
    deleteStudent(studentId: $studentId,mobile:$mobile)
  }
`;

class StudentsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      BreadcrumbData: {
        Title: "Students",
        btnName1: 'Add Student',
        btnName2: 'Update User',
      },
      currentStep: 1,
      studentid: "",
      branch: "",
      section: "",
      class: "",
      exam: "",
      student_name: "",
      password: "",
      contact_no: "",
      package: "",
      category: "",
      submitError: "",
      formErrors: {
        branch: "",
        section: "",
        class: "",
        category: "",
        student_name: "",
        contact_no: "",
        package: "",
        password: "",
        confirmPassword: "",
        exam: ""
      },
      branchValid: true,
      sectionValid: true,
      classValid: true,
      student_nameValid: true,
      contact_noValid: true,
      packageValid: true,
      categoryValid: true,
      formValid: false,
      BranchesSection: {
        Title: "Students",
        btnName: "Add Student",
      },
      tableHeaderData: {
        Title: "Students",
      },
      modalShow: false,
      modalShow1: false,
      modalShow2: false,

      updateSection: false,

      status: 0,
      editRow: {},

      //fields for search
      confirmPassword: "",
      passwordValid: true,
      examValid: true,
      confirmPasswordValid: true,
      cButton: true,
      mobile: "",
      loadingSpinner: 0,


      // Filer Fields 
      getStateArr: [],
      statesSelectedValue: [],
      getDistricts: [],
      selectedDistrictsValues: [],
      getCities: [],
      selectedCityValue: [],
      getBranchArr: [],
      getExamArr: [],
      getClassArr: [],
      getSectionArr: [],
      branchSelectedvalue: [],
      examSelectedvalue: [],
      classSelectedvalue: [],
      sectionSelectedvalue: [],
      showFilter: false,
      accessDeniedShow: false
    };

    this.guard = attachModuleGuard(this, ACADEMIC_STUDENTS_MODULE);
  };



  // componentDidMount() {
  //   let branchData = this.props.globals.globalBranches;
  //   let getExamArr = [];
  //   let getClassArr = [];
  //   let getSectionArr = [];


  //   if (branchData.length > 0) {

  //     let getStateArr = this.props.globals.states.map((b) => ({
  //       value: b.state_id,
  //       label: b.state_name,
  //     }));

  //     const stateIds = getStateArr.map((b) => Number(b.value));
  //     const districts = this.props.globals.districts.filter((item) => stateIds.includes(Number(item.state_id))).map((district) => ({ value: district.id, label: district.district_name }));
  //     const districtIds = districts.map((item) => Number(item.value));
  //     const cityIds = districts.map((b) => Number(b.value));
  //     const cityes = this.props.globals.cities.filter((item) => cityIds.includes(Number(item.district_id))).map((city) => ({ value: city.id, label: city.city_name }));

  //     const filteredBranches = branchData.filter((branch) =>
  //       (stateIds.length === 0 || stateIds.includes(Number(branch.state_id))) ||
  //       (districtIds.length === 0 || districtIds.includes(Number(branch.district_id))) ||
  //       (cityIds.length === 0 || cityIds.includes(Number(branch.city_id)))
  //     )

  //     let getBranchArr = filteredBranches.map((b) => ({
  //       value: b.id,
  //       label: b.branch_name,
  //     }));

  //     let selectedBranches = getBranchArr.map((b) => ({
  //       value: b.value,
  //       label: b.label,
  //     }));

  //     let branchIds = selectedBranches.map((b) => Number(b.value));

  //     let uniqueExams = [
  //       ...new Set(
  //         this.props.globals.b_e_c_s_data
  //           .filter((item) => branchIds.includes(Number(item.branch_id)))
  //           .map((item1) => Number(item1.exam_id))
  //       ),
  //     ].sort((a, b) => a - b);


  //     uniqueExams.map((val) => {
  //       let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
  //       const newObj = {
  //         value: individualExamData.id,
  //         label: individualExamData.exam
  //       }
  //       getExamArr.push(newObj);
  //     });


  //     let selectedExamsValues = getExamArr.map((item) => item.value);

  //     let uniqueClasses = [];

  //     if (selectedExamsValues.length > 0) {

  //       selectedExamsValues.map((val) => {
  //         let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
  //         uniqueClasses.push(...individualClassValues)
  //       });
  //     }

  //     if (uniqueClasses.length > 0) {
  //       [...new Set(uniqueClasses)].map((val) => {
  //         let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
  //         const newObj = {
  //           value: individualClassData.id,
  //           label: individualClassData.class
  //         }
  //         getClassArr.push(newObj);
  //       });

  //       let selectedClasses = getClassArr.map((item) => item.value);


  //       //section selection

  //       let uniqueSections = [];

  //       if (selectedClasses.length > 0) {
  //         selectedExamsValues.map((val) => {
  //           selectedClasses.map((val1) => {
  //             let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
  //             if (individualsectionValues.length > 0) {
  //               uniqueSections.push(...individualsectionValues)
  //             }
  //           })
  //         });
  //       }

  //       if (uniqueSections.length > 0) {
  //         [...new Set(uniqueSections)].map((val) => {
  //           let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
  //           const newObj = {
  //             value: individualSectionData.id,
  //             label: individualSectionData.section_name
  //           }
  //           getSectionArr.push(newObj);
  //         });
  //       }
  //     }

  //     this.setState({
  //       getStateArr: getStateArr,
  //       getDistricts: districts,
  //       getBranchArr: selectedBranches,
  //       getExamArr: getExamArr,
  //       getClassArr: getClassArr,
  //       getSectionArr: getSectionArr,

  //       getCities: cityes,
  //       selectedCityValue: cityes,

  //       statesSelectedValue: getStateArr,
  //       selectedDistrictsValues: districts,
  //       branchSelectedvalue: selectedBranches,
  //       examSelectedvalue: getExamArr,
  //       classSelectedvalue: getClassArr,
  //       sectionSelectedvalue: getSectionArr

  //     })
  //   }
  // };

  // Branches this page may show: the header's (NavbarOne) selection, narrowed to
  // the branches the user is authorized for. This replaces the page's own Branch
  // multi-select — every cascade below (exam → class → section) derives from it.
  scopedGlobalBranches = () =>
    scopeBranches((this.props.globals && this.props.globals.globalBranches) || []);

  componentDidMount() {
    this.initFilters();
    // Branch comes from the header (NavbarOne) — rebuild the whole
    // branch → exam → class → section cascade from the new scope.
    this.offBranchScope = onBranchScopeChange(() => this.initFilters());
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }

  initFilters() {
    const getValue = (b) => Number(b.value ?? b);

    let branchData = this.scopedGlobalBranches();

    let getExamArr = [];
    let getClassArr = [];
    let getSectionArr = [];

    if (branchData.length > 0) {

      // ================= STATES =================
      let getStateArr = this.props.globals.states.map((b) => ({
        value: b.state_id,
        label: b.state_name,
      }));

      const stateIds = getStateArr.map(getValue);

      // ================= DISTRICTS =================
      const districts = this.props.globals.districts
        .filter((item) =>
          stateIds.length === 0 || stateIds.includes(Number(item.state_id))
        )
        .map((d) => ({
          value: d.id,
          label: d.district_name,
        }));

      const districtIds = districts.map(getValue);

      // ================= CITIES =================
      const cityes = this.props.globals.cities
        .filter((item) =>
          districtIds.length === 0 || districtIds.includes(Number(item.district_id))
        )
        .map((c) => ({
          value: c.id,
          label: c.city_name,
        }));

      const cityIds = cityes.map(getValue);

      // ================= BRANCHES =================
      const getBranchArr = branchData
        .filter((branch) =>
          (stateIds.length === 0 || stateIds.includes(Number(branch.state_id))) &&
          (districtIds.length === 0 || districtIds.includes(Number(branch.district_id))) &&
          (cityIds.length === 0 || cityIds.includes(Number(branch.city_id)))
        )
        .map((b) => ({
          value: b.id,
          label: b.branch_name,
        }));

      const branchIds = getBranchArr.map(getValue);

      // ================= EXAMS =================
      let uniqueExams = [
        ...new Set(
          this.props.globals.b_e_c_s_data
            .filter((item) =>
              branchIds.length === 0 || branchIds.includes(Number(item.branch_id))
            )
            .map((item) => Number(item.exam_id))
        ),
      ];

      uniqueExams.forEach((val) => {
        let exam = this.props.globals.exams.find((e) => e.id == val);
        if (exam) {
          getExamArr.push({
            value: exam.id,
            label: exam.exam,
          });
        }
      });

      const examIds = getExamArr.map(getValue);

      // ================= CLASSES =================
      let uniqueClasses = [
        ...new Set(
          this.props.globals.b_e_c_s_data
            .filter((item) =>
              (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
              (examIds.length === 0 || examIds.includes(Number(item.exam_id)))
            )
            .map((item) => Number(item.class_id))
        ),
      ];

      uniqueClasses.forEach((val) => {
        let cls = this.props.globals.educationalClasses.find((c) => c.id == val);
        if (cls) {
          getClassArr.push({
            value: cls.id,
            label: cls.class,
          });
        }
      });

      const classIds = getClassArr.map(getValue);

      // ================= SECTIONS =================
      let uniqueSections = [
        ...new Set(
          this.props.globals.b_e_c_s_data
            .filter((item) =>
              (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
              (examIds.length === 0 || examIds.includes(Number(item.exam_id))) &&
              (classIds.length === 0 || classIds.includes(Number(item.class_id)))
            )
            .map((item) => Number(item.section_id))
        ),
      ];

      uniqueSections.forEach((val) => {
        let sec = this.props.globals.globalSections.find((s) => s.id == val);
        if (sec) {
          getSectionArr.push({
            value: sec.id,
            label: sec.section_name,
          });
        }
      });

      // ================= FINAL STATE =================
      this.setState({
        getStateArr: getStateArr,
        statesSelectedValue: getStateArr,

        getDistricts: districts,
        selectedDistrictsValues: districts,

        getCities: cityes,
        selectedCityValue: cityes,

        getBranchArr: getBranchArr,
        branchSelectedvalue: getBranchArr,

        getExamArr: getExamArr,
        examSelectedvalue: getExamArr,

        getClassArr: getClassArr,
        classSelectedvalue: getClassArr,

        getSectionArr: getSectionArr,
        sectionSelectedvalue: getSectionArr,
      });
    }
  }

  tableData(students) {
    const student_data = Array();

    for (let i = 0; i < students.length; i++) {

      const statesData = this.props.globals.states.find(
        (e) => e.state_id == students[i].state_id
      );

      let state_id = "";
      let state_name = "";
      if (statesData != undefined) {
        state_name = statesData.state_name;
        state_id = statesData.state_id;
      }


      const districtData = this.props.globals.districts.find(
        (e) => e.id == students[i].district_id
      );

      let district_id = "";
      let district_name = "";
      if (districtData != undefined) {
        district_name = districtData.district_name;
        state_id = districtData.state_id;
      }

      const cityData = this.props.globals.cities.find(
        (e) => e.id == students[i].city_id
      );

      let city_id = "";
      let city_name = "";
      if (cityData != undefined) {
        city_name = cityData.city_name;
        city_id = cityData.city_id;
      }


      const branchs = this.props.globals.globalBranches.find(
        (e) => e.id == students[i].branch_id
      );
      let b_id = "";
      let branch1 = "";
      if (branchs != undefined) {
        branch1 = branchs.branch_name;
        b_id = branchs.id;
      }


      const exams = this.props.globals.exams.find(
        (e) => e.id == students[i].exam_id
      );
      let exam_id = "";
      let examName = "";
      if (exams != undefined) {
        examName = exams.exam;
        exam_id = exams.id;
      }

      const classes = this.props.globals.classes.find(
        (e) => e.id == students[i].class_id
      );
      let c_id = "";
      let class1 = "";
      if (classes != undefined) {
        class1 = classes.class;
        c_id = classes.id;
      }
      const packages = this.props.globals.globalPackages.find(
        (e) => e.id == students[i].package_id
      );
      let p_id = "";
      let package1 = "";
      if (packages != undefined) {
        package1 = packages.package_name;
        p_id = packages.id;
      }
      const categories = this.props.globals.globalCategories.find(
        (e) => e.id == students[i].category_id
      );
      let cc_id = "";
      let category1 = "";
      if (categories != undefined) {
        category1 = categories.category_name;
        cc_id = categories.id;
      }
      const sections = this.props.globals.globalSections.find(
        (e) => e.id == students[i].section_id
      );
      let s_id = "";
      let section1 = "";
      if (sections != undefined) {
        section1 = sections.section_name;
        s_id = sections.id;
      }

      student_data.push({
        id: students[i].id,
        student_name: students[i].student_name,
        contact_no: students[i].contact_no,
        exam_name: examName,
        exam_id: exam_id,
        state_id: state_id,
        state_name: state_name,
        district_id: district_id,
        district_name: district_name,
        city_id: city_id,
        city_name: city_name,
        branch_name: branch1,
        class_name: class1,
        package_id: package1,
        category_id: category1,
        section_name: section1,
        branch: b_id,
        class: c_id,
        package: p_id,
        category: cc_id,
        section: s_id,
        is_academic_exist: students[i].is_academic_exist,
        is_non_academic_exist: students[i].is_non_academic_exist
      });
    }

    return student_data;
  }

  dataUpdate = (e) => {
    this.setState({ currentStep: e.currentStep, loadingSpinner: e.loadingSpinner })
  }

  handleFormSubmit = (e) => {
    e.preventDefault();

    // Re-checked at submit, not only when the modal opened: the modal could already
    // be open when a grant changes.
    if (!this.guard.requireEdit()) {
      this.setState({ modalShow1: false });
      return;
    }

    console.log("Form submitted", this.state.formValid);

    if (this.state.formValid) {
      let editStudent = {
        id: this.state.studentid,
        section_id: parseInt(this.state.section),
        class_id: parseInt(this.state.class),
        exam_id: parseInt(this.state.exam),
        branch_id: parseInt(this.state.branch),
        student_name: this.state.student_name,
        contact_no: this.state.contact_no,
        username: Cookies.get("username"),
      };

      this.editStudent(editStudent).catch((error) => {
        console.log("catch if error");
        console.log(error);
        this.setState({
          submitError: error.graphQLErrors.map((x) => x.message),
        });
        console.error(
          "ERR =>",
          error.graphQLErrors.map((x) => x.message)
        );
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed" });
    }
  };

  // Last gate before the EDIT_STUDENT mutation leaves the client.
  editStudent = async (params) => {
    if (!this.guard.requireEdit()) return;

    await this.props.editStudent({
      variables: {
        params,
      },
      update: (store, { data }) => {
        let data1 = store.readQuery({
          query: FETCH_STUDENTS,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
          },
        });

        const student = data1.getStudents.findIndex(
          (th) => th.id == this.state.studentid
        );

        data1.getStudents[student].student_name = this.state.student_name;
        data1.getStudents[student].contact_no = this.state.contact_no;
        data1.getStudents[student].branch_id = this.state.branch;
        data1.getStudents[student].class_id = this.state.class;
        data1.getStudents[student].section_id = this.state.section;
        data1.getStudents[student].exam_id = this.state.exam;
        try {
          store.writeQuery({
            query: FETCH_STUDENTS,
            variables: {
              institution_id: parseInt(Cookies.get("institutionid")),
            },
            data: data1,
          });
        } catch (e) {
          console.log("Exception", e);
        }

        console.log("editstudent", data);

        if (data.editStudent) {
          this.setState({
            currentStep: 5,
            student_name: "",
            contact_no: "",
            branch: "",
            package: "",
            category: "",
            section: "",
            class: "",
            studentid: "",
            submitError: "",
            formErrors: {
              student_name: "",
              contact_no: "",
              package: "",
              branch: "",
              class: "",
              category: "",
              section: "",
            },
            student_nameValid: true,
            contact_noValid: true,
            packageValid: true,
            categoryValid: true,
            classValid: true,
            branchValid: true,
            sectionValid: true,
            formValid: false,
          });
          setTimeout(() => {
            this.SetpageLoad();
          }, 1500);
        }
      },
    });
  };

  SetpageLoad = () => {
    //console.log("setTimeout");
    this.setState({
      currentStep: 1,
      modalShow1: false,
    });
    //this.props.onHide()
  };

  handleInputChange = (e) => {
    console.log("e.target.name", e.target.name);
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  };

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let branchValid = this.state.branchValid;
    let sectionValid = this.state.sectionValid;
    let classValid = this.state.classValid;
    let student_nameValid = this.state.student_nameValid;
    let contact_noValid = this.state.contact_noValid;
    let packageValid = this.state.packageValid;
    let categoryValid = this.state.categoryValid;
    let passwordValid = this.state.passwordValid;
    let confirmPasswordValid = this.state.confirmPasswordValid;
    let cButton = this.state.cButton;
    let password = this.state.password;
    let confirmPassword = this.state.confirmPassword
    let section = this.state.section;
    let examValid = this.state.examValid

    switch (fieldName) {
      case "branch":
        if (value.length == "") {
          branchValid = false;
          fieldValidationErrors.branch = "Select Branch";
        } else {
          branchValid = true;
          fieldValidationErrors.branch = "";

        }

        break;

      case "exam":
        if (value.length == "") {
          examValid = false;
          fieldValidationErrors.exam = "Select exam";
        } else {
          examValid = true;
          fieldValidationErrors.exam = "";
          section = ""
          sectionValid = false
        }

        break;

      case "section":
        if (value.length == "") {
          sectionValid = false;
          fieldValidationErrors.section = "Select Section";
        } else {
          sectionValid = true;
          fieldValidationErrors.section = "";
        }

        break;

      case "class":
        if (value.length == "") {
          classValid = false;
          fieldValidationErrors.class = "Select Class";
        } else {
          classValid = true;
          fieldValidationErrors.class = "";
        }
        break;

      case "student_name":
        if (value.length == "") {
          student_nameValid = false;
          fieldValidationErrors.student_name = "Name Cannot Be Empty";
        } else {
          student_nameValid = true;
          fieldValidationErrors.student_name = "";
        }
        break;


      case "password":
        if (value.length == "") {
          passwordValid = false;
          cButton = true;
          confirmPassword = "";
          confirmPasswordValid = false;
          fieldValidationErrors.confirmPassword = "";
          fieldValidationErrors.password = "password Cannot Be Empty";
        } else if (value.length < 6) {
          passwordValid = false;
          cButton = true;
          confirmPasswordValid = false;
          confirmPassword = ""
          fieldValidationErrors.confirmPassword = "";
          fieldValidationErrors.password = "Password must be 6 characters";
        } else {
          passwordValid = true;
          fieldValidationErrors.password = "";
          cButton = false
        }
        break;

      case "confirmPassword":
        if (value.length == "") {
          confirmPasswordValid = false;
          fieldValidationErrors.confirmPassword = "Confirm password Cannot Be Empty";
        } else if (value.length < 6) {
          confirmPasswordValid = false;
          fieldValidationErrors.confirmPassword = "Confirm password must be 6 characters";
        }
        else if (this.state.password != this.state.confirmPassword) {
          confirmPasswordValid = false;
          fieldValidationErrors.confirmPassword = "confirm password not matched";
        }
        else {
          confirmPasswordValid = true;
          fieldValidationErrors.confirmPassword = "";
        }
        break;


      case "contact_no":
        // var pattern = new RegExp("^[6-9][0-9]{9}$");
        const pattern = /^[1-9]\d{9}$/gi;
        if (value.length == "") {
          contact_noValid = false;
          fieldValidationErrors.contact_no = "contact No. Cannot Be Empty";
        } else if (!pattern.test(value)) {
          contact_noValid = false;
          fieldValidationErrors.contact_no = "Invalid contact No.";
        } else {
          contact_noValid = true;
          fieldValidationErrors.contact_no = "";
        }

        break;

      case "package":
        if (value.length == "") {
          packageValid = false;
          fieldValidationErrors.package = "Select Package";
        } else {
          packageValid = true;
          fieldValidationErrors.package = "";
        }
        break;
      case "category":
        if (value.length == "") {
          categoryValid = false;
          fieldValidationErrors.category = "Select Package";
        } else {
          categoryValid = true;
          fieldValidationErrors.category = "";
        }
        break;

      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        branchValid: branchValid,
        sectionValid: sectionValid,
        classValid: classValid,
        student_nameValid: student_nameValid,
        contact_noValid: contact_noValid,
        packageValid: packageValid,
        categoryValid: categoryValid,
        confirmPasswordValid: confirmPasswordValid,
        passwordValid: passwordValid,
        cButton: cButton,
        confirmPassword: confirmPassword,
        password: password,
        section: section,
        examValid: examValid
      },
      this.validateForm
    );
  }



  validateForm() {
    this.setState({
      formValid:
        this.state.branchValid &&
        this.state.sectionValid &&
        this.state.classValid &&
        this.state.student_nameValid &&
        this.state.contact_noValid &&
        this.state.packageValid &&
        this.state.categoryValid &&
        this.state.passwordValid &&
        this.state.confirmPasswordValid &&
        this.state.examValid,
    });
    if (this.state.formValid) {
      this.setState({ submitError: "" }, () => { });
    }
  }

  actionsFormatter2(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" name="delete" className="text-danger">
          <i className="far fa-trash-alt" />
        </Button>
      </div>
    );
  }
  actionsFormatter3() {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" name="edit" className="text-theme">
          <i className="far fa-lock " />
        </Button>
      </div>
    );
  }

  actionsFormatter1() {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" name="edit" className="text-theme">
          <i className="far fa-edit" />
        </Button>
      </div>
    );
  }

  actionsFormatter(cell, row, rowIndex, formatExtraData) {
    return (
      <div className="actions-buttons d-flex justify-content-center align-items-top">
        <Button variant="link" name="view" className="text-theme">
          <i className="far fa-eye" />
        </Button>
      </div>
    );
  }

  // Row "edit" icon — checked before the edit modal opens, so a role without is_edit
  // never sees a form it isn't allowed to save. The icon stays visible and clickable.
  handleEditFunction = (e, cell, row, rowIndex, formatExtraData) => {
    if (!this.guard.requireEdit()) return;

    console.log("rowIndex", rowIndex);
    this.setState({
      modalShow1: true,
      studentid: rowIndex.id,
      student_name: rowIndex.student_name,
      contact_no: rowIndex.contact_no,
      package: rowIndex.package,
      branch: rowIndex.branch,
      class: rowIndex.class,
      category: rowIndex.category,
      section: rowIndex.section,
      exam: rowIndex.exam_id
    });
  };

  // Resetting a student's password is a write → is_edit. Checked before the modal opens.
  handleChangePassword = (e, cell, row, rowIndex, formatExtraData) => {
    if (!this.guard.requireEdit()) return;

    console.log("rowIndex", rowIndex);
    this.setState({
      modalShow2: true,
      mobile: rowIndex.contact_no,
    });
  };

  // This deletes with NO confirm dialog — the click goes straight to the mutation, so
  // the grant check here is the only thing standing between the click and the delete.
  handleDelete = async (e, cell, row, rowIndex, formatExtraData) => {
    if (!this.guard.requireDelete()) return;

    console.log("rowIndex", rowIndex);
    await this.props.handleDelete({
      variables: {
        studentId: rowIndex.id,
        mobile: rowIndex.contact_no
      },
      update: (store, { data }) => {
        console.log("data", data);
        const data1 = store.readQuery({
          query: FETCH_STUDENTS,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
          },
        });
        console.log("data1s", data1.getStudents);
        console.log("rowIndex.id", rowIndex.id);
        data1.getStudents = data1.getStudents.filter(
          (x) => x.id != rowIndex.id
        );
        console.log("data2s", data1.getStudents);
        try {
          store.writeQuery({
            query: FETCH_STUDENTS,
            variables: {
              institution_id: parseInt(Cookies.get("institutionid")),
            },
            data: data1,
          });
        } catch (e) {
          console.log("Exception", e);
        }

        const data4 = store.readQuery({
          query: FETCH_STUDENTS,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
          },
        });
        data1.getStudents = data4;
        console.log("data4s", data4);
        if (data.deleteStudent) {
          this.setState({
            currentStep: 5,
          });
          setTimeout(() => {
            this.DeleteSetpageLoad();
          }, 1000);
        }
      },
    });
  };

  DeleteSetpageLoad = () => {
    console.log("setTimeout");
    this.setState({ currentStep: 1 });
  };



  handlePasswordSubmit = () => {
    // e.preventDefault();
    if (!this.guard.requireEdit()) {
      this.setState({ modalShow2: false });
      return;
    }

    if (this.state.passwordValid && this.state.confirmPasswordValid) {
      this.setState({ loadingSpinner: 1 });
      const params = {
        mobile: this.state.mobile,
        password: this.state.confirmPassword
      }
      console.log("noteshandleFormSubmit", params);
      this.passwordUpdate(
        params

      ).catch(error => {
        console.log(error);
        this.setState({
          submitError2: error.graphQLErrors.map(x => x.message)
        });
        console.error("ERR =>", error.graphQLErrors.map(x => x.message));
      });
    } else {
      this.setState({ submitError: "Please fill all the values to proceed" });
    }
  };

  // Last gate before the UPDATE_PASSWORD mutation leaves the client.
  passwordUpdate = async (
    params) => {
    if (!this.guard.requireEdit()) return;

    await this.props.updatePassword({
      variables: {
        params
      },
      update: (store, { data }) => {
        console.log("data", data);
        if (data.updatePassword) {
          this.setState({
            currentStep: 5,
          });
          setTimeout(() => {
            this.SetpageLoad2();
          }, 1000);
        }
      }
    });
  };
  SetpageLoad2 = () => {
    console.log("");
    this.setState({ currentStep: 1, modalShow2: false, password: "", confirmPassword: "", formErrors: { password: "", confirmPassword: "" }, passwordValid: false, confirmPasswordValid: false, cButton: true, mobile: "", loadingSpinner: 0 });
  }

  articlecolumns = [
    {
      dataField: "student_name",
      text: "Student Name",
      sort: true,
      formatter: this.studentNameFunc.bind(this),
    },
    {
      dataField: "state_name",
      text: "State Name",
      sort: true,
    },
    {
      dataField: "district_name",
      text: "District Name",
      sort: true,
    },
    {
      dataField: "city_name",
      text: "City Name",
      sort: true,
    },
    {
      dataField: "branch_name",
      text: "Branch",
      sort: true,
    },
    {
      dataField: "exam_name",
      text: "Exam",
      sort: true,
    },
    {
      dataField: "class_name",
      text: "Class",
      sort: true,
    },
    {
      dataField: "section_name",
      text: "Section",
      sort: true,
    },
    {
      dataField: "contact_no",
      text: "Contact No",
      sort: true,
    },
    {
      dataField: "actions",
      formatter: this.actionsFormatter1,
      headerAttrs: { width: 50 },
      attrs: { width: 50, className: "EditRow" },
      headerAlign: "center",
      events: {
        onClick: this.handleEditFunction,
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.actionsFormatter3,
      headerAttrs: { width: 50 },
      attrs: { width: 50, className: "EditRow" },
      headerAlign: "center",
      events: {
        onClick: this.handleChangePassword,
      },
    },
    {
      dataField: "actions",
      formatter: this.actionsFormatter2,
      headerAttrs: { width: 50 },
      attrs: { width: 50, className: "EditRow" },
      headerAlign: "center",
      events: {
        onClick: this.handleDelete,
      },
    },

  ];


  studentNameFunc(cell, row, rowIndex, formatExtraData) {


    let row1 = [];

    if (row != null) {
      row1.push({ class_id: row.class, branch_id: row.branch, section_id: row.section, profile_pic: "", student_name: row.student_name, contact_no: row.roll_no, exam_id: row.exam_id, contact_no: row.contact_no, is_academic_exist: row.is_academic_exist, is_non_academic_exist: row.is_non_academic_exist })
    }


    return (<>
      <div className="text-link d-flex flex-column">
        <Link
          style={{ textDecoration: "none", color: "blue" }} // remove underline here
          to={{
            pathname: "/home/student-profile",
            back: "/settings/students",
            state: {
              row: row1[0],
              rowIndex: rowIndex,
              type: "academic"
            }
          }}
        >
          <span
            style={{
              color: "#000",
              textDecoration: "underline",
              textDecorationColor: "#000" // 👈 underline also black
            }}
          >
            {row["student_name"]}
          </span>
        </Link>
      </div>
    </>)
  };



  handleMultipleSelectInputChange = (e, name) => {
    const { globals } = this.props;
    let getExamArr = [];
    let getClassArr = [];
    let getSectionArr = [];

    if (name === "states") {
      const getValue = (b) => Number(b.value ?? b);

      const stateData = globals.states;

      if (stateData.length > 0) {

        // ✅ Selected States
        const selectedStates = e.map((b) => ({
          value: b.value,
          label: b.label,
        }));

        const stateIds = selectedStates.map(getValue);

        // ================= DISTRICTS =================
        const districts = globals.districts
          .filter((item) =>
            stateIds.length === 0 || stateIds.includes(Number(item.state_id))
          )
          .map((d) => ({
            value: d.id,
            label: d.district_name,
          }));

        const districtIds = districts.map(getValue);

        // ================= CITIES =================
        const cityes = globals.cities
          .filter((item) =>
            districtIds.length === 0 || districtIds.includes(Number(item.district_id))
          )
          .map((c) => ({
            value: c.id,
            label: c.city_name,
          }));

        // ================= BRANCHES =================
        const getBranchArr = this.scopedGlobalBranches()
          .filter((item) =>
            stateIds.length === 0 || stateIds.includes(Number(item.state_id))
          )
          .map((b) => ({
            value: b.id,
            label: b.branch_name,
          }));

        const branchIds = getBranchArr.map(getValue);

        // ================= EXAMS =================
        let uniqueExams = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (stateIds.length === 0 || stateIds.includes(Number(item.state_id)))
              )
              .map((item) => Number(item.exam_id))
          ),
        ];

        let getExamArr = [];

        uniqueExams.forEach((val) => {
          let exam = this.props.globals.exams.find((e) => e.id == val);
          if (exam) {
            getExamArr.push({
              value: exam.id,
              label: exam.exam,
            });
          }
        });

        const examIds = getExamArr.map(getValue);

        // ================= CLASSES =================
        let uniqueClasses = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (examIds.length === 0 || examIds.includes(Number(item.exam_id)))
              )
              .map((item) => Number(item.class_id))
          ),
        ];

        let getClassArr = [];

        uniqueClasses.forEach((val) => {
          let cls = this.props.globals.educationalClasses.find((c) => c.id == val);
          if (cls) {
            getClassArr.push({
              value: cls.id,
              label: cls.class,
            });
          }
        });

        const classIds = getClassArr.map(getValue);

        // ================= SECTIONS =================
        let uniqueSections = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (examIds.length === 0 || examIds.includes(Number(item.exam_id))) &&
                (classIds.length === 0 || classIds.includes(Number(item.class_id)))
              )
              .map((item) => Number(item.section_id))
          ),
        ];

        let getSectionArr = [];

        uniqueSections.forEach((val) => {
          let sec = this.props.globals.globalSections.find((s) => s.id == val);
          if (sec) {
            getSectionArr.push({
              value: sec.id,
              label: sec.section_name,
            });
          }
        });

        // ================= FINAL STATE =================
        this.setState({
          statesSelectedValue: selectedStates,

          selectedDistrictsValues: districts,
          getDistricts: districts,

          selectedCityValue: cityes,
          getCities: cityes,

          getBranchArr: getBranchArr,
          branchSelectedvalue: getBranchArr,

          getExamArr: getExamArr,
          examSelectedvalue: getExamArr,

          getClassArr: getClassArr,
          classSelectedvalue: getClassArr,

          getSectionArr: getSectionArr,
          sectionSelectedvalue: getSectionArr,
        });

      } else {
        this.setState({
          statesSelectedValue: [],
          selectedDistrictsValues: [],
          getDistricts: [],
          selectedCityValue: [],
          getCities: [],
          getBranchArr: [],
          getExamArr: [],
          getClassArr: [],
          getSectionArr: [],
          examSelectedvalue: [],
          classSelectedvalue: [],
          sectionSelectedvalue: [],
          branchSelectedvalue: [],
        });
      }
    } else if (name === "districts") {
      const getValue = (b) => Number(b.value ?? b);

      const districtData = globals.districts;

      if (districtData.length > 0) {

        // ✅ Selected Districts
        const selectedistrict = e.map((b) => ({
          value: b.value,
          label: b.label,
        }));

        // ✅ IDs
        const stateIds = this.state.statesSelectedValue.map(getValue);
        const districtIds = selectedistrict.map(getValue);

        // ✅ Cities
        const cityes = globals.cities
          .filter((item) =>
            districtIds.length === 0 || districtIds.includes(Number(item.district_id))
          )
          .map((city) => ({
            value: city.id,
            label: city.city_name,
          }));

        // ✅ Branches
        const branchData = this.scopedGlobalBranches();

        let getBranchArr = branchData
          .filter((item) =>
            (stateIds.length === 0 || stateIds.includes(Number(item.state_id))) &&
            (districtIds.length === 0 || districtIds.includes(Number(item.district_id)))
          )
          .map((b) => ({
            value: b.id,
            label: b.branch_name,
          }));

        const branchIds = getBranchArr.map(getValue);

        // ================== EXAMS ==================

        let uniqueExams = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (stateIds.length === 0 || stateIds.includes(Number(item.state_id))) &&
                (districtIds.length === 0 || districtIds.includes(Number(item.district_id)))
              )
              .map((item) => Number(item.exam_id))
          ),
        ].sort((a, b) => a - b);

        let getExamArr = [];

        uniqueExams.forEach((val) => {
          let exam = this.props.globals.exams.find((e) => e.id == val);
          if (exam) {
            getExamArr.push({
              value: exam.id,
              label: exam.exam,
            });
          }
        });

        const examIds = getExamArr.map(getValue);

        // ================== CLASSES ==================

        let uniqueClasses = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (examIds.length === 0 || examIds.includes(Number(item.exam_id)))
              )
              .map((item) => Number(item.class_id))
          ),
        ];

        let getClassArr = [];

        uniqueClasses.forEach((val) => {
          let cls = this.props.globals.educationalClasses.find((c) => c.id == val);
          if (cls) {
            getClassArr.push({
              value: cls.id,
              label: cls.class,
            });
          }
        });

        const classIds = getClassArr.map(getValue);

        // ================== SECTIONS ==================

        let uniqueSections = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (examIds.length === 0 || examIds.includes(Number(item.exam_id))) &&
                (classIds.length === 0 || classIds.includes(Number(item.class_id)))
              )
              .map((item) => Number(item.section_id))
          ),
        ];

        let getSectionArr = [];

        uniqueSections.forEach((val) => {
          let sec = this.props.globals.globalSections.find((s) => s.id == val);
          if (sec) {
            getSectionArr.push({
              value: sec.id,
              label: sec.section_name,
            });
          }
        });

        // ================== FINAL STATE ==================

        this.setState({
          selectedDistrictsValues: selectedistrict,
          getCities: cityes,
          selectedCityValue: cityes,

          getBranchArr: getBranchArr,
          branchSelectedvalue: getBranchArr,

          getExamArr: getExamArr,
          examSelectedvalue: getExamArr,

          getClassArr: getClassArr,
          classSelectedvalue: getClassArr,

          getSectionArr: getSectionArr,
          sectionSelectedvalue: getSectionArr,
        });

      } else {
        this.setState({
          statesSelectedValue: [],
          selectedDistrictsValues: [],
          getDistricts: [],
          selectedCityValue: [],
          getCities: [],
          getBranchArr: [],
          getExamArr: [],
          getClassArr: [],
          getSectionArr: [],
          examSelectedvalue: [],
          classSelectedvalue: [],
          sectionSelectedvalue: [],
          branchSelectedvalue: [],
        });
      }
    } else if (name === "cities") {
      const getValue = (b) => Number(b.value ?? b);

      const cityData = globals.cities;

      if (cityData.length > 0) {

        // ✅ Selected Cities
        const selectecity = e.map((b) => ({
          value: b.value,
          label: b.label,
        }));

        // ✅ IDs
        const stateIds = this.state.statesSelectedValue.map(getValue);
        const districtIds = this.state.selectedDistrictsValues.map(getValue);
        const cityIds = selectecity.map(getValue);

        // ================= BRANCHES =================
        const getBranchArr = this.scopedGlobalBranches()
          .filter((item) =>
            (stateIds.length === 0 || stateIds.includes(Number(item.state_id))) &&
            (districtIds.length === 0 || districtIds.includes(Number(item.district_id))) &&
            (cityIds.length === 0 || cityIds.includes(Number(item.city_id)))
          )
          .map((b) => ({
            value: b.id,
            label: b.branch_name,
          }));

        const branchIds = getBranchArr.map(getValue);

        // ================= EXAMS =================
        let uniqueExams = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (stateIds.length === 0 || stateIds.includes(Number(item.state_id))) &&
                (districtIds.length === 0 || districtIds.includes(Number(item.district_id))) &&
                (cityIds.length === 0 || cityIds.includes(Number(item.city_id)))
              )
              .map((item) => Number(item.exam_id))
          ),
        ];

        let getExamArr = [];

        uniqueExams.forEach((val) => {
          let exam = this.props.globals.exams.find((e) => e.id == val);
          if (exam) {
            getExamArr.push({
              value: exam.id,
              label: exam.exam,
            });
          }
        });

        const examIds = getExamArr.map(getValue);

        // ================= CLASSES =================
        let uniqueClasses = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (examIds.length === 0 || examIds.includes(Number(item.exam_id)))
              )
              .map((item) => Number(item.class_id))
          ),
        ];

        let getClassArr = [];

        uniqueClasses.forEach((val) => {
          let cls = this.props.globals.educationalClasses.find((c) => c.id == val);
          if (cls) {
            getClassArr.push({
              value: cls.id,
              label: cls.class,
            });
          }
        });

        const classIds = getClassArr.map(getValue);

        // ================= SECTIONS =================
        let uniqueSections = [
          ...new Set(
            this.props.globals.b_e_c_s_data
              .filter((item) =>
                (branchIds.length === 0 || branchIds.includes(Number(item.branch_id))) &&
                (examIds.length === 0 || examIds.includes(Number(item.exam_id))) &&
                (classIds.length === 0 || classIds.includes(Number(item.class_id)))
              )
              .map((item) => Number(item.section_id))
          ),
        ];

        let getSectionArr = [];

        uniqueSections.forEach((val) => {
          let sec = this.props.globals.globalSections.find((s) => s.id == val);
          if (sec) {
            getSectionArr.push({
              value: sec.id,
              label: sec.section_name,
            });
          }
        });

        // ================= FINAL STATE =================
        this.setState({
          selectedCityValue: selectecity,

          getBranchArr: getBranchArr,
          branchSelectedvalue: getBranchArr,

          getExamArr: getExamArr,
          examSelectedvalue: getExamArr,

          getClassArr: getClassArr,
          classSelectedvalue: getClassArr,

          getSectionArr: getSectionArr,
          sectionSelectedvalue: getSectionArr,
        });

      } else {
        this.setState({
          getBranchArr: [],
          getExamArr: [],
          getClassArr: [],
          getSectionArr: [],
          examSelectedvalue: [],
          classSelectedvalue: [],
          sectionSelectedvalue: [],
          branchSelectedvalue: [],
        });
      }
    } else if (name === "branch") {
      let getExamArr = [];
      let getClassArr = [];
      let getSectionArr = [];

      const branchData = globals.globalBranches;

      if (branchData.length > 0) {
        const selectedBranches = e.map((b) => ({
          value: b.value,
          label: b.label,
        }));

        const branchIds = selectedBranches.map((b) => Number(b.value));
        const stateIds = this.state.statesSelectedValue.map((item) => Number(item.value));
        const districtIds = this.state.selectedDistrictsValues.map((item) => Number(item.value));
        const cityIds = this.state.selectedCityValue.map((item) => Number(item.value));

        const stateCityDistrictWiseBranches = globals.b_e_c_s_data.filter((branch) => {
          return (
            (stateIds.length === 0 || stateIds.includes(Number(branch.state_id))) &&
            (districtIds.length === 0 || districtIds.includes(Number(branch.district_id))) &&
            (cityIds.length === 0 || cityIds.includes(Number(branch.city_id)))
          );
        })

        // ✅ Unique Exams for selected branches
        let uniqueExams = [
          ...new Set(
            stateCityDistrictWiseBranches
              .filter((item) => branchIds.includes(Number(item.branch_id)))
              .map((item1) => Number(item1.exam_id))
          ),
        ].sort((a, b) => a - b);

        uniqueExams.forEach((val) => {
          const examData = globals.exams.find((ex) => ex.id == val);
          if (examData) {
            getExamArr.push({
              value: examData.id,
              label: examData.exam,
            });
          }
        });

        const selectedExamValues = getExamArr.map((i) => i.value);
        let uniqueClasses = [];

        // ✅ Classes for all selected branches + exams
        if (selectedExamValues.length > 0) {
          branchIds.forEach((branchId) => {
            selectedExamValues.forEach((examId) => {
              const classIds = [
                ...new Set(
                  globals.b_e_c_s_data
                    .filter(
                      (item) =>
                        item.branch_id == branchId && item.exam_id == examId
                    )
                    .map((i) => i.class_id)
                ),
              ];
              uniqueClasses.push(...classIds);
            });
          });
        }

        // ✅ Build class options
        [...new Set(uniqueClasses)].forEach((classId) => {
          const classData = globals.educationalClasses.find(
            (c) => c.id == classId
          );
          if (classData) {
            getClassArr.push({
              value: classData.id,
              label: classData.class,
            });
          }
        });

        const selectedClassValues = getClassArr.map((i) => i.value);
        let uniqueSections = [];

        // ✅ Sections for all selected branches + exams + classes
        if (selectedClassValues.length > 0) {
          branchIds.forEach((branchId) => {
            selectedExamValues.forEach((examId) => {
              selectedClassValues.forEach((classId) => {
                const sectionIds = [
                  ...new Set(
                    globals.b_e_c_s_data
                      .filter(
                        (item) =>
                          item.branch_id == branchId &&
                          item.exam_id == examId &&
                          item.class_id == classId
                      )
                      .map((i) => i.section_id)
                  ),
                ];
                uniqueSections.push(...sectionIds);
              });
            });
          });
        }

        // ✅ Build section options
        [...new Set(uniqueSections)].forEach((secId) => {
          const secData = globals.globalSections.find((s) => s.id == secId);
          if (secData) {
            getSectionArr.push({
              value: secData.id,
              label: secData.section_name,
            });
          }
        });

        // ✅ Update State (All selected by default)
        this.setState({
          branchSelectedvalue: selectedBranches,
          getExamArr,
          getClassArr,
          getSectionArr,
          examSelectedvalue: getExamArr,
          classSelectedvalue: getClassArr,
          sectionSelectedvalue: getSectionArr,
        });
      }
    }

    // ✅ EXAM SELECTION
    if (name === "exam") {
      let examSelectedvalue = [];
      let getClassArr = [];
      let getSectionArr = [];

      if (e.length > 0) {
        e.forEach((exam) => {
          examSelectedvalue.push({
            label: exam.label,
            value: exam.value,
          });
        });

        const selectedExamValues = examSelectedvalue.map((i) => i.value);
        const branchIds = this.state.branchSelectedvalue.map((b) => b.value);
        let uniqueClasses = [];

        // ✅ Get classes for selected exams + branches
        branchIds.forEach((branchId) => {
          selectedExamValues.forEach((examId) => {
            const classIds = [
              ...new Set(
                globals.b_e_c_s_data
                  .filter(
                    (item) =>
                      item.branch_id == branchId && item.exam_id == examId
                  )
                  .map((i) => i.class_id)
              ),
            ];
            uniqueClasses.push(...classIds);
          });
        });

        [...new Set(uniqueClasses)].forEach((classId) => {
          const classData = globals.educationalClasses.find(
            (c) => c.id == classId
          );
          if (classData) {
            getClassArr.push({
              value: classData.id,
              label: classData.class,
            });
          }
        });

        const selectedClassValues = getClassArr.map((i) => i.value);
        let uniqueSections = [];

        // ✅ Get sections
        branchIds.forEach((branchId) => {
          selectedExamValues.forEach((examId) => {
            selectedClassValues.forEach((classId) => {
              const sectionIds = [
                ...new Set(
                  globals.b_e_c_s_data
                    .filter(
                      (item) =>
                        item.branch_id == branchId &&
                        item.exam_id == examId &&
                        item.class_id == classId
                    )
                    .map((i) => i.section_id)
                ),
              ];
              uniqueSections.push(...sectionIds);
            });
          });
        });

        [...new Set(uniqueSections)].forEach((secId) => {
          const secData = globals.globalSections.find((s) => s.id == secId);
          if (secData) {
            getSectionArr.push({
              value: secData.id,
              label: secData.section_name,
            });
          }
        });

        this.setState({
          examSelectedvalue,
          getClassArr,
          classSelectedvalue: getClassArr,
          getSectionArr,
          sectionSelectedvalue: getSectionArr,
        });
      } else {
        this.setState({
          examSelectedvalue: [],
          getClassArr: [],
          classSelectedvalue: [],
          getSectionArr: [],
          sectionSelectedvalue: [],
        });
      }
    }

    // ✅ CLASS SELECTION
    if (name === "class") {
      let classSelectedvalue = [];
      let getSectionArr = [];

      if (e.length > 0) {
        e.forEach((cls) => {
          classSelectedvalue.push({
            label: cls.label,
            value: cls.value,
          });
        });

        const selectedExamValues = this.state.examSelectedvalue.map((i) => i.value);
        const selectedClassValues = classSelectedvalue.map((i) => i.value);
        const branchIds = this.state.branchSelectedvalue.map((b) => b.value);
        let uniqueSections = [];

        branchIds.forEach((branchId) => {
          selectedExamValues.forEach((examId) => {
            selectedClassValues.forEach((classId) => {
              const sectionIds = [
                ...new Set(
                  globals.b_e_c_s_data
                    .filter(
                      (item) =>
                        item.branch_id == branchId &&
                        item.exam_id == examId &&
                        item.class_id == classId
                    )
                    .map((i) => i.section_id)
                ),
              ];
              uniqueSections.push(...sectionIds);
            });
          });
        });

        [...new Set(uniqueSections)].forEach((secId) => {
          const secData = globals.globalSections.find((s) => s.id == secId);
          if (secData) {
            getSectionArr.push({
              value: secData.id,
              label: secData.section_name,
            });
          }
        });

        this.setState({
          classSelectedvalue,
          getSectionArr,
          sectionSelectedvalue: getSectionArr,
        });
      } else {
        this.setState({
          classSelectedvalue: [],
          getSectionArr: [],
          sectionSelectedvalue: [],
        });
      }
    }

    // ✅ SECTION SELECTION
    if (name === "section") {
      let sectionSelectedvalue = [];

      if (e && e.length > 0) {
        sectionSelectedvalue = e.map((sec) => ({
          label: sec.label,
          value: sec.value,
        }));
      }

      this.setState({
        sectionSelectedvalue,
      });
    }

  };

  handleButtonClick = (rowId) => {
    if (rowId === 9) {
      this.setState({ showFilter: !this.state.showFilter });
    }

    if (rowId === 8) {
      this.setState({
        showFilter: true,
        statesSelectedValue: [],
        selectedDistrictsValues: [],
        selectedCityValue: [],
        branchSelectedvalue: [],
        examSelectedvalue: [],
        classSelectedvalue: [],
        sectionSelectedvalue: []
      });
    }
  };

  // "Add Student" opens StudentModal (which owns the create mutation); "Update User"
  // opens UpdateStudentsModal (bulk section reassignment). Both are is_edit actions, so
  // the openers are gated — the buttons themselves stay visible and clickable.
  openAddStudentModal = () => {
    if (!this.guard.requireEdit()) return;
    this.setState({ modalShow: true });
  };

  openUpdateSectionModal = () => {
    if (!this.guard.requireEdit()) return;
    this.setState({ updateSection: true });
  };

  render() {
    // is_view === 0 → the student data is never rendered, and FETCH_STUDENTS is skipped
    // so nothing is fetched. This MUST stay above the getStudents prop reads below: with
    // the query skipped that prop is undefined and `getStudents.loading` would throw.
    // The page shell comes from Students.jsx, so the user can still navigate away.
    if (!this.guard.canView()) {
      return (
        <section className="students_section">
          <AccessDeniedCard />
        </section>
      );
    }

    const getStudents = this.props.getStudents;
    const loading2 = getStudents.loading;
    const error2 = getStudents.error;

    if (loading2) return null;

    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    let StudentsFilterData = [];

    if (this.state.statesSelectedValue.length > 0 ||
      this.state.selectedDistrictsValues.length > 0 ||
      this.state.selectedCityValue.length > 0 ||
      this.state.branchSelectedvalue.length > 0 ||
      this.state.examSelectedvalue.length > 0 ||
      this.state.classSelectedvalue.length > 0 ||
      this.state.sectionSelectedvalue.length > 0
    ) {
      StudentsFilterData = getStudents.getStudents || [];

      // STATE
      if (this.state.statesSelectedValue.length > 0) {
        const stateIds = this.state.statesSelectedValue.map((b) => Number(b.value));

        StudentsFilterData = StudentsFilterData.filter((item) =>
          stateIds.includes(Number(item.state_id))
        );
      }

      // DISTRICT
      if (this.state.selectedDistrictsValues.length > 0) {
        const districtIds = this.state.selectedDistrictsValues.map((b) => Number(b.value));

        StudentsFilterData = StudentsFilterData.filter((item) =>
          districtIds.includes(Number(item.district_id))
        );
      }

      // CITY
      if (this.state.selectedCityValue.length > 0) {
        const cityIds = this.state.selectedCityValue.map((b) => Number(b.value));

        StudentsFilterData = StudentsFilterData.filter((item) =>
          cityIds.includes(Number(item.city_id))
        );
      }


      if (this.state.branchSelectedvalue.length > 0) {
        const branchIds = this.state.branchSelectedvalue.map((b) => Number(b.value));

        StudentsFilterData = StudentsFilterData.filter((item) =>
          branchIds.includes(Number(item.branch_id))
        );
      }

      if (this.state.examSelectedvalue.length > 0) {
        const examIds = this.state.examSelectedvalue.map((b) => Number(b.value));

        StudentsFilterData = StudentsFilterData.filter((item) =>
          examIds.includes(Number(item.exam_id))
        );
      }


      if (this.state.classSelectedvalue.length > 0) {
        const classIds = this.state.classSelectedvalue.map((b) => Number(b.value));

        StudentsFilterData = StudentsFilterData.filter((item) =>
          classIds.includes(Number(item.class_id))
        );
      }

      if (this.state.sectionSelectedvalue.length > 0) {
        const sectionIds = this.state.sectionSelectedvalue.map((b) => Number(b.value));
        StudentsFilterData = StudentsFilterData.filter((item) =>
          sectionIds.includes(Number(item.section_id))
        );
      }

    } else {
      StudentsFilterData = getStudents.getStudents || [];
    }


    const studentData = this.tableData(getStudents.getStudents) || [];

    let stateselectall = true;
    let statelabelledBy = "Select";
    let statedisableSearch = false;

    let districtselectall = true;
    let districtlabelledBy = "Select";
    let districtdisableSearch = false;

    let cityselectall = true;
    let citylabelledBy = "Select";
    let cityisableSearch = false;


    let examselectall = true;
    let examlabelledBy = "Select";
    let examdisableSearch = false;

    let classselectall = true;
    let classlabelledBy = "Select";
    let classdisableSearch = false;

    if (this.props.globals.states.length > 0) {
      stateselectall = true;
      statedisableSearch = false;
    }
    else {
      statedisableSearch = true;
      stateselectall = false;
      statelabelledBy = "State"
    }

    if (this.props.globals.districts.length > 0) {
      districtselectall = true;
      districtdisableSearch = false;
    }
    else {
      districtdisableSearch = true;
      districtselectall = false;
      districtlabelledBy = "State"
    }

    if (this.props.globals.cities.length > 0) {
      cityselectall = true;
      cityisableSearch = false;
    }
    else {
      cityisableSearch = true;
      cityselectall = false;
      citylabelledBy = "State"
    }


    // No branch label/select-all state — the Branch row was removed from the filter
    // bar; the header (NavbarOne) scopes this page.

    if (this.props.globals.exams.length > 0) {
      examselectall = true;
      examdisableSearch = false;
    }
    else {
      examdisableSearch = true;
      examselectall = false;
      examlabelledBy = "Exam"
    }

    if (this.props.globals.classes.length > 0) {
      classselectall = true;
      classdisableSearch = false;
    }
    else {
      classdisableSearch = true;
      classselectall = false;
      classlabelledBy = "Class"
    }


    let sectionselectall = true;
    let sectionlabelledBy = "Select";
    let sectiondisableSearch = false;


    if (this.props.globals.globalSections.length > 0) {
      sectionselectall = true;
      sectiondisableSearch = false;
    }
    else {
      sectiondisableSearch = true;
      sectionselectall = false;
      sectionlabelledBy = "Section"
    }

    const studentFilterArr = [
      { rowId: 1, allItems: "All States are selected", labelledBy: statelabelledBy, disableSearch: statedisableSearch, selectAll: stateselectall, options: this.state.getStateArr, value: this.state.statesSelectedValue, name: "states", controlId: "Select State" },
      { rowId: 2, allItems: "All Districts are selected", labelledBy: districtlabelledBy, disableSearch: districtdisableSearch, selectAll: districtselectall, options: this.state.getDistricts, value: this.state.selectedDistrictsValues, name: "districts", controlId: "Select Districts" },
      { rowId: 2, allItems: "All Cities are selected", labelledBy: citylabelledBy, disableSearch: cityisableSearch, selectAll: cityselectall, options: this.state.getCities, value: this.state.selectedCityValue, name: "cities", controlId: "Select City" },
      // No Branch row — the header's branch selection scopes this page.
      { rowId: 5, allItems: "All Exams are selected", labelledBy: examlabelledBy, disableSearch: examdisableSearch, selectAll: examselectall, options: this.state.getExamArr, value: this.state.examSelectedvalue, name: "exam", controlId: "Select Exam" },
      { rowId: 6, allItems: "All Classes are selected", labelledBy: classlabelledBy, disableSearch: classdisableSearch, selectAll: classselectall, options: this.state.getClassArr, value: this.state.classSelectedvalue, name: "class", controlId: "Select Class" },
      { rowId: 7, allItems: "All Sections are selected", labelledBy: sectionlabelledBy, disableSearch: sectiondisableSearch, selectAll: sectionselectall, options: this.state.getSectionArr, value: this.state.sectionSelectedvalue, name: "section", controlId: "Select Section" },
      // { rowId: 8, type: "Reset" },
      // { rowId: 9, type: "Cancel" }
    ];

    return (
      <section className="students_section">
        <Row>
          <Col xl={12} lg={12} md={12} sm={12}>
            <BreadcrumbsSection
              addStudentButton={this.openAddStudentModal}
              updateSectionButton={this.openUpdateSectionModal}
              breadcrumbs={this.state.BreadcrumbData}
              type="multiple"
            />
          </Col>

          <div className="d-flex justify-content-end col-12">
            <Col sm={12} className="text-right mb-1">
              <Button onClick={() => this.setState({ showFilter: !this.state.showFilter })}
                className="btn-sm border-0 bg-transparent"><i className="fa fa-filter" style={{ color: this.state.showFilter ? "#007bff" : "#6c757d" }}></i></Button>
            </Col>
          </div>

          <Col xl={12} lg={12} md={12} sm={12} className="studentTable">
            <Card as={Card.Body} className="border-0 shadow-sm mb-4">
              {this.state.showFilter &&
                <Card.Header className="w-100">
                  <Row>
                    {
                      studentFilterArr.map((item) => (
                        <Col sm={[8, 9].includes(item.rowId) ? 1 : 3} className="mt-2" controlId={item.controlId} key={item.name}>
                          {
                            [8, 9].includes(item.rowId) ? (
                              <div className="mt-4">
                                <Button
                                  variant={item.rowId === 8 ? "warning" : "danger"}
                                  onClick={() => this.handleButtonClick(item.rowId)}
                                >
                                  {item.type}
                                </Button>
                              </div>
                            ) : (
                              <>
                                <h6 className="text-uppercase">{item.controlId}</h6>
                                <MultiSelect
                                  overrideStrings={{
                                    allItemsAreSelected: `${item.allItems}`,
                                    selectSomeItems: item.labelledBy,
                                  }}
                                  disableSearch={item.disableSearch}
                                  hasSelectAll={item.allItems}
                                  options={item.options}
                                  value={item.value}
                                  onChange={(e) => this.handleMultipleSelectInputChange(e, item.name)}
                                  labelledBy={item.name}
                                />
                              </>
                            )
                          }
                        </Col>
                      ))
                    }
                  </Row>
                </Card.Header>
              }

              <Card.Body>
                <CardLessDataTableWithSearch
                  parentData={this.tableData(StudentsFilterData)}
                  particlecolumns={this.articlecolumns}
                  tableHeading={this.state.tableHeaderData}
                  defaultSorted={defaultSorted}
                  name="Student"
                />
              </Card.Body>
            </Card>
          </Col>


          <StudentModal
            dataUpdates={this.dataUpdate}
            stateData={this.state}
            globals={this.props.globals}
            show={this.state.modalShow}
            onHide={() => this.setState({ modalShow: false })}
          />
          <StudentModalEdit
            handleFormSubmit={this.handleFormSubmit}
            parenthandleInputChange={this.handleInputChange}
            globals={this.props.globals}
            stateData={this.state}
            show={this.state.modalShow1}
            onHide={() => this.setState({ modalShow1: false })}
          />
          <StudentPasswordModal
            handlePasswordSubmit={this.handlePasswordSubmit}
            parenthandleInputChange={this.handleInputChange}
            stateData={this.state}
            show={this.state.modalShow2}
            onHide={() => this.setState({ modalShow2: false, password: "", confirmPassword: "", formErrors: { password: "", confirmPassword: "" }, passwordValid: false, confirmPasswordValid: "", cButton: true, mobile: "" })}
          />

          <UpdateStudentsModal
            show={this.state.updateSection}
            globals={this.props.globals}
            studentData={studentData}
            onHide={() => this.setState({ updateSection: false })}
          />

          {/* Shown instead of creating / editing / resetting a password / deleting
              when the grant is missing. One modal serves every intercepted action. */}
          <AccessDeniedModal
            show={this.state.accessDeniedShow}
            onHide={this.guard.hideAccessDenied}
          />
        </Row>
      </section>
    );
  }
}

export default withRouter(
  compose(
    // skip: is_view === 0 → don't fetch the student list at all. Only the READ query
    // is skipped; skipping a mutation HOC would remove the prop function entirely and
    // the guarded handlers would throw "this.props.X is not a function".
    graphql(FETCH_STUDENTS, {
      options: (props) => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
        },
        fetchPolicy: "cache-and-network",
      }),
      skip: () => !canView(ACADEMIC_STUDENTS_MODULE),
      name: "getStudents",
    }),

    graphql(DELETE_STUDENT, {
      name: "handleDelete",
    }),
    graphql(UPDATE_PASSWORD, {
      name: "updatePassword",
    }),
    graphql(EDIT_STUDENT, {
      name: "editStudent",
    })
  )(StudentsSection)
);